import React, { useContext } from 'react';
import { MFContext } from '@4r/mf-host';
import { useParams, Redirect } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { PageStatus } from '../../state/Actions';
import { UserContext } from '../../contexts/UserContext';
import { ReferenceDataContext } from '../../contexts/ReferenceDataContext';
import { AuthContext } from '../../authentication/AuthProvider';
import { useGlobalState } from '../../state/Store';
import ROUTES from '../../routes/constants';

import './WorkOrderPage.scss';

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);

const Listing: React.FunctionComponent = () => {
	const { WorkOrderMicrofrontend } = useContext(MFContext);
	const { id } = useParams<{ id: string }>();
	if (!id || id === 'undefined') {
		return <Redirect to="/orders" />;
	}

	const referenceData = useContext(ReferenceDataContext);
	const [onlineStatus] = useGlobalState('online');

	const isOnline = onlineStatus !== PageStatus.offline;
	const user = useContext(UserContext);
	const { getUser } = useContext(AuthContext);
	const currentUser = getUser();

	if (!WorkOrderMicrofrontend) return null;

	// Legacy offline removal: the MF now loads its own order detail via
	// `@4r/common-module-offline-services` (`useOrderDetails`), so the host no
	// longer feeds `orders` / `workOrders` / `reloadOrders` / `orderPersisterService`
	// from `OfflineOrderContext`, nor tracks the current order id via the legacy
	// `CurrentOrderIdService`.
	return (
		<WorkOrderMicrofrontend
			workOrderId={id}
			user={user.current}
			vendorId={user.current?.vendor?.id}
			online={isOnline}
			hostReferenceData={referenceData}
			currentUserName={currentUser ? `${currentUser.given_name} ${currentUser.family_name}` : undefined}
			lifecycleUrl={`/${ROUTES.LIFECYCLES}`}
			onlyMobileView
		/>
	);
};

export default Listing;
